export const useActionCellStyles = () => ({
  actionCell: {
    whiteSpace: 'nowrap' as const,
    textAlign: 'right' as const,
    padding: 0,
    // must be non-0 value
    width: '1%',
  },
});
